import classNames from "classnames";
import { useRef } from "react";
import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";
import { useSelector } from "react-redux";
import LogoutBlock from "components/molecules/LogoutBlock";
import PageTitle from "components/atoms/PageTitle";
import AccountDataBlockContainer from "containers/molecules/AccountPersonalDataContainer";
import { createSearchParams, useNavigate } from "react-router-dom";
import LoyaltyButton from "components/atoms/LoyaltyButton";
import { useSplitServiceData } from "queries/useSplitServiceData";
import { GET_PARAMS, GET_POPUP_TYPES } from "../../../../constants/popupConfig";
import CoinFestProfile from "../../../molecules/CoinFestProfile";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import useScrollDetection from "../../../../hooks/useScrollDetection";
import ProfileWidgetContainer from "../../../../containers/organisms/ProfileWidgetContainer";
import { ACCOUNT_NAVIGATION } from "../../../../constants/navigation/profile";
import MobileMenu from "../../../organisms/MobileMenu";
import "./styles.sass";
import * as userSelector from "../../../../redux/user/selectors";

const AccountPage = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const contentRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrollDetection(contentRef);
  const { loyaltyAccess } = useSplitServiceData();

  const handleBack = () => {
    navigate({
      ...(!isDesktop && {
        search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.sideMenu })}`,
      }),
    });
  };

  const AccountPageHeader = classNames("AccountPage-mobile__header", {
    border: isScrolled,
  });

  const hasFirstDeposit = useSelector(userSelector.hasFirstDeposit);
  const currency = useSelector(userSelector.currency);
  const isAvailableGeo =
    currency?.isoCode === "BDT" ||
    currency?.isoCode === "TRY" ||
    currency?.isoCode === "AZN" ||
    currency?.isoCode === "INR" ||
    currency?.isoCode === "KZT" ||
    currency?.isoCode === "UZS" ||
    currency?.isoCode === "PKR";

  return (
    <>
      <SEO pathname={url.routes.profile.index()} />
      <div className="AccountPage">
        <div className="AccountPage-mobile" ref={contentRef}>
          <div className={AccountPageHeader}>
            <PageTitle title="profile.account.title" onBack={handleBack} />
          </div>
          <div className="AccountPage-mobile__balance">
            {/* <BalanceInfoContainer type="mono" /> */}
            {loyaltyAccess ? <ProfileWidgetContainer /> : null}
          </div>
          {loyaltyAccess ? <LoyaltyButton /> : null}
          {`${import.meta.env.VITE_APP_PROJECT_NAME}` === "glory" &&
            hasFirstDeposit &&
            isAvailableGeo && <CoinFestProfile />}
          <MobileMenu list={ACCOUNT_NAVIGATION} />
          <div className="AccountPage-mobile__logout">
            <LogoutBlock />
          </div>
        </div>
        <div className="AccountPage-desktop">
          <AccountDataBlockContainer />
        </div>
      </div>
    </>
  );
};

export default AccountPage;
